export default "__VITE_ASSET__CUGPah9N__"